module.exports = [{
      plugin: require('../gatsby-browser.tsx'),
      options: {"plugins":[]},
    },{
      plugin: require('../../node_modules/.pnpm/gatsby@5.13.3_patch_hash=2a570fd1984fae97a95cb12efcc80df19163b98bb476ace7d4552ce1e8e9fc_f3eb8c147160ae089b1a8ca7766d5124/node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
